import tmhRequest from '@/config/tmhRequest'

export default {

    login: function (data) {
        return tmhRequest({
            url: '/hr/ispa/account/login',
            method: 'post',
            params: data,
        })
    },

    register: function (data) {
        return tmhRequest({
            url: '/hr/ispa/account/register',
            method: 'post',
            params: data,
        })
    },

    searchMenu: function (data) {
        return tmhRequest({
            url: '/hr/tmh/account/searchmenu',
            method: 'post',
            params: data,
        })
    },

    searchBelongCompany: function (data) {
        return tmhRequest({
            url: '/hr/tmh/account/searchbelongcompany',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/hr/account.js